/**
 * Telegram Migration API Schemas
 */

import { z } from "zod";

export const TelegramMigrationRecordSchema = z.object({
  id: z.string(),
  connectionId: z.string(),
  botUsername: z.string(),
  currentWebhookUrl: z.string(),
  expectedWebhookUrl: z.string(),
  webhookStatus: z.enum(["synced", "not_synced"]),
  hasSecretToken: z.boolean(),
  migratedAt: z.string().datetime().nullable()
});

export const TelegramMigrationStatusResponseSchema = z.object({
  total: z.number(),
  synced: z.number(),
  notSynced: z.number(),
  secured: z.number(),
  notSecured: z.number(),
  bots: z.array(TelegramMigrationRecordSchema)
});

export const MigrateTelegramWebhookBodySchema = z.object({
  connectionId: z.string().uuid()
});

export const MigrateTelegramWebhookResponseSchema = z.object({
  success: z.boolean(),
  webhookUrl: z.string().optional(),
  hasSecretToken: z.boolean().optional(),
  error: z.string().optional()
});
